import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'
import { PaginationQueryParams } from '@forwardflow/types'
import useSWR from 'swr'

export const useGetAllLeadSources = (queryParams: PaginationQueryParams) => {
   const response = useSWR(
      [QUERY_KEYS.GET_ALL_LEAD_SOURCES, { ...queryParams }],
      () => CampaignService.getAllLeadSources(queryParams)
   )
   return {
      ...response,
   }
}
